import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, withCtx as _withCtx, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = ["data-qa"]
const _hoisted_2 = { class: "gfu-navbar gfu-project-navigation__navbar gfu-navbar--lighter" }
const _hoisted_3 = { class: "gfu-project-navigation-main__side _screen--none _screen--flex-xl" }
const _hoisted_4 = ["title"]
const _hoisted_5 = { class: "gfu-project-navigation-main__project" }
const _hoisted_6 = ["href"]
const _hoisted_7 = {
  key: 0,
  class: "gfu-navbar-nav gfu-project-navigation-main__header"
}
const _hoisted_8 = { class: "gfu-navbar-item gfu-project-navigation-main__title" }
const _hoisted_9 = ["data-qa"]
const _hoisted_10 = { class: "_toe" }
const _hoisted_11 = {
  key: 1,
  class: "gfu-project-navigation-main__nav gfu-navbar-nav gfu-navbar-nav--scrollable"
}
const _hoisted_12 = { class: "gfu-navbar-nav__wrapper" }
const _hoisted_13 = ["data-qa"]
const _hoisted_14 = ["href"]
const _hoisted_15 = {
  key: 0,
  class: "gfu-navbar-badge _ml-1",
  "data-qa": "project-navigation-badge"
}
const _hoisted_16 = { class: "gfu-project-navigation-main__side" }
const _hoisted_17 = { class: "gfu-navbar gfu-navbar--lighter" }
const _hoisted_18 = { class: "gfu-project-navigation-main is-stuck" }
const _hoisted_19 = { class: "gfu-navbar-nav gfu-project-navigation-main__header" }
const _hoisted_20 = { class: "gfu-navbar-item gfu-project-navigation-main__title" }
const _hoisted_21 = ["href"]
const _hoisted_22 = { class: "_toe" }
const _hoisted_23 = {
  ref: "list",
  class: "gfu-list"
}
const _hoisted_24 = { class: "gfu-navbar-link--disabled" }
const _hoisted_25 = ["href", "title"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_project_navigation_archive = _resolveComponent("project-navigation-archive")
  const _component_base_image = _resolveComponent("base-image")
  const _component_base_icon = _resolveComponent("base-icon")
  const _component_project_navigation_main_item = _resolveComponent("project-navigation-main-item")
  const _component_project_quick_actions = _resolveComponent("project-quick-actions")
  const _component_top_navigation_spacer = _resolveComponent("top-navigation-spacer")
  const _component_tooltip = _resolveComponent("tooltip")
  const _component_router_indicator = _resolveComponent("router-indicator")
  const _component_drawer = _resolveComponent("drawer")
  const _component_return_to_element = _resolveComponent("return-to-element")
  const _component_project_context_modal = _resolveComponent("project-context-modal")

  return (_openBlock(), _createElementBlock("div", {
    id: "project-navigation",
    ref: "navigation",
    class: _normalizeClass(['gfu-project-navigation', {'is-open': _ctx.drawerIsOpen}]),
    "data-qa": `project-navigation-sticky:${_ctx.isStuck}`
  }, [
    (_ctx.isProjectInPhasePreview)
      ? (_openBlock(), _createBlock(_component_project_navigation_archive, {
          key: 0,
          "project-url": $options.projectUrl
        }, null, 8 /* PROPS */, ["project-url"]))
      : _createCommentVNode("v-if", true),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: _normalizeClass(['gfu-project-navigation-main', {'is-stuck': _ctx.isStuck}])
      }, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("a", {
            class: "gfu-project-navigation-main__logo",
            href: "/",
            title: $options.platformName
          }, [
            _createVNode(_component_base_image, {
              alt: $options.platformName,
              src: "/content/images/site-icon.svg"
            }, null, 8 /* PROPS */, ["alt"])
          ], 8 /* PROPS */, _hoisted_4),
          _createElementVNode("h3", _hoisted_5, [
            _createElementVNode("a", {
              class: "gfu-link--nofx",
              href: $options.projectUrl,
              onClick: _cache[0] || (_cache[0] = (...args) => ($options.onProjectNameClicked && $options.onProjectNameClicked(...args)))
            }, _toDisplayString($options.projectName), 9 /* TEXT, PROPS */, _hoisted_6)
          ])
        ]),
        (_ctx.isStuck && $options.enableDrawer)
          ? (_openBlock(), _createElementBlock("nav", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("a", {
                  class: "gfu-navbar-link is-active",
                  href: "#projectUrl",
                  onClick: _cache[1] || (_cache[1] = _withModifiers($event => ($options.showDrawer(false)), ["prevent"])),
                  "data-qa": `project-navigation-link:${$options.header}`
                }, [
                  _createVNode(_component_base_icon, {
                    name: "chevron-down",
                    class: "gfu-navbar-icon"
                  }),
                  _createElementVNode("span", _hoisted_10, _toDisplayString($options.header), 1 /* TEXT */)
                ], 8 /* PROPS */, _hoisted_9)
              ])
            ]))
          : (_openBlock(), _createElementBlock("nav", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.itemsWithBadges, (link, index) => {
                  return (_openBlock(), _createElementBlock(_Fragment, null, [
                    (link.isActive && $options.hasSections && index === 0)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: `${link.name}-section`,
                          ref_for: true,
                          ref: "mainNavigationItem",
                          class: "gfu-navbar-item is-active",
                          "data-qa": `project-navigation-link:${link.name}`
                        }, [
                          _createElementVNode("a", {
                            class: "gfu-navbar-link",
                            href: link.url,
                            onClick: _cache[2] || (_cache[2] = _withModifiers($event => ($options.showDrawer(true)), ["prevent"]))
                          }, [
                            _createVNode(_component_base_icon, {
                              name: "chevron-down",
                              class: "gfu-navbar-icon _screen--not-xl"
                            }),
                            _createElementVNode("span", null, _toDisplayString(link.name), 1 /* TEXT */),
                            (link.badgeText)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(link.badgeText), 1 /* TEXT */))
                              : _createCommentVNode("v-if", true)
                          ], 8 /* PROPS */, _hoisted_14)
                        ], 8 /* PROPS */, _hoisted_13))
                      : (_openBlock(), _createBlock(_component_project_navigation_main_item, {
                          key: link.name,
                          ref_for: true,
                          ref: "mainNavigationItem",
                          link: link
                        }, null, 8 /* PROPS */, ["link"]))
                  ], 64 /* STABLE_FRAGMENT */))
                }), 256 /* UNKEYED_FRAGMENT */))
              ])
            ])),
        _createElementVNode("div", _hoisted_16, [
          _createVNode(_component_project_quick_actions)
        ])
      ], 2 /* CLASS */)
    ]),
    _createVNode(_component_drawer, {
      "is-open": _ctx.drawerIsOpen,
      onClose: $options.hideDrawer
    }, {
      header: _withCtx(() => [
        ($options.isPWA)
          ? (_openBlock(), _createBlock(_component_top_navigation_spacer, { key: 0 }))
          : _createCommentVNode("v-if", true),
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("nav", _hoisted_19, [
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("a", {
                  class: "gfu-navbar-link is-active",
                  href: $options.projectUrl,
                  onClick: _cache[3] || (_cache[3] = _withModifiers((...args) => ($options.hideDrawer && $options.hideDrawer(...args)), ["prevent"]))
                }, [
                  _createVNode(_component_base_icon, {
                    name: "times",
                    class: "gfu-navbar-icon"
                  }),
                  _createElementVNode("span", _hoisted_22, _toDisplayString($options.header), 1 /* TEXT */)
                ], 8 /* PROPS */, _hoisted_21)
              ])
            ]),
            _createVNode(_component_project_quick_actions, { class: "gfu-project-navigation-main__side" })
          ])
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("nav", _hoisted_23, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.itemsWithBadges, (link, index) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
              (link.isRestricted)
                ? (_openBlock(), _createElementBlock("div", {
                    key: link.name,
                    class: "gfu-list-item"
                  }, [
                    _createVNode(_component_tooltip, {
                      text: link.restrictionReason,
                      "vertical-position": "down"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", _hoisted_24, [
                          _createElementVNode("span", null, _toDisplayString(link.name), 1 /* TEXT */)
                        ])
                      ]),
                      _: 2 /* DYNAMIC */
                    }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["text"])
                  ]))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    (_openBlock(), _createElementBlock("a", {
                      key: link.name,
                      class: _normalizeClass(['gfu-list-item', {'is-active': link.isActive}]),
                      href: link.url,
                      title: link.label
                    }, _toDisplayString(link.name), 11 /* TEXT, CLASS, PROPS */, _hoisted_25)),
                    (link.isActive && $options.hasSections)
                      ? (_openBlock(), _createElementBlock("nav", {
                          key: `section-${link.name}${index}`
                        }, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pageSections, (section) => {
                            return (_openBlock(), _createElementBlock(_Fragment, {
                              key: `section-${section.name}`
                            }, [
                              (section.urlName)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    _createVNode(_component_router_indicator, {
                                      "active-class": "is-active",
                                      class: "gfu-list-subitem",
                                      "exact-active-class": "is-exact-active",
                                      href: "#",
                                      tag: "a",
                                      to: { name: 'page-section', params: { section: section.urlName }},
                                      onClick: _withModifiers($event => ($options.onSectionClicked({ section: section.urlName })), ["prevent"])
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(section.name), 1 /* TEXT */)
                                      ]),
                                      _: 2 /* DYNAMIC */
                                    }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["to", "onClick"]),
                                    (section.sections && section.sections.length)
                                      ? (_openBlock(), _createElementBlock("nav", {
                                          key: `subsection-${section.name}`
                                        }, [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(section.sections, (subSection) => {
                                            return (_openBlock(), _createElementBlock(_Fragment, {
                                              key: `${section.urlName}/${subSection.urlName}`
                                            }, [
                                              (subSection.urlName)
                                                ? (_openBlock(), _createBlock(_component_router_indicator, {
                                                    key: 0,
                                                    "active-class": "is-active",
                                                    class: "gfu-list-subitem gfu-list-subitem--indent",
                                                    "exact-active-class": "is-exact-active",
                                                    href: "#",
                                                    tag: "a",
                                                    to: { name: 'page-section', params: { section: section.urlName, subSection: subSection.urlName }},
                                                    onClick: _withModifiers($event => ($options.onSectionClicked({ section: section.urlName, subSection: subSection.urlName })), ["prevent"])
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createTextVNode(_toDisplayString(subSection.name), 1 /* TEXT */)
                                                    ]),
                                                    _: 2 /* DYNAMIC */
                                                  }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["to", "onClick"]))
                                                : _createCommentVNode("v-if", true)
                                            ], 64 /* STABLE_FRAGMENT */))
                                          }), 128 /* KEYED_FRAGMENT */))
                                        ]))
                                      : _createCommentVNode("v-if", true)
                                  ], 64 /* STABLE_FRAGMENT */))
                                : _createCommentVNode("v-if", true)
                            ], 64 /* STABLE_FRAGMENT */))
                          }), 128 /* KEYED_FRAGMENT */))
                        ]))
                      : _createCommentVNode("v-if", true)
                  ], 64 /* STABLE_FRAGMENT */))
            ], 64 /* STABLE_FRAGMENT */))
          }), 256 /* UNKEYED_FRAGMENT */))
        ], 512 /* NEED_PATCH */)
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["is-open", "onClose"]),
    _createVNode(_component_return_to_element),
    _createVNode(_component_project_context_modal)
  ], 10 /* CLASS, PROPS */, _hoisted_1))
}